import {type PaletteOptions} from '@mui/material/styles';

export const themePaletteLight: PaletteOptions = {
  background: {paper: '#f5f5f5', default: '#E7E7E7'},
  text: {primary: '#121212', secondary: '#525252'},
};
